import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Tip:`}</strong>{` We recommend using a `}<inlineCode parentName="p">{`[object] [verb]`}</inlineCode>{` format for your event names, where `}<inlineCode parentName="p">{`[object]`}</inlineCode>{` is the entity that the behavior relates to, and `}<inlineCode parentName="p">{`[verb]`}</inlineCode>{` is the behavior itself. For example, `}<inlineCode parentName="p">{`project created`}</inlineCode>{`, `}<inlineCode parentName="p">{`user signed up`}</inlineCode>{`, or `}<inlineCode parentName="p">{`invite sent`}</inlineCode>{`.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      